<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <p>{{ workOrder.title }}</p>
    <p>Assigned to: {{ workOrder.assignee }}</p>
    <template #bottom>
      <div class="px-4 pb-6">
        <p v-if="workOrder.hours_scoped">
          Estimated hours: {{ workOrder.hours_scoped }}
        </p>
        <p v-if="workOrder.hours_recorded">
          Recorded hours: {{ workOrder.hours_recorded }}
        </p>

        <div class="customer-address mt-3">
          <p>Customer name</p>
          <p>1 Address Way</p>
          <p>Scottsdale, AZ</p>
        </div>

        <bdg-files-list class="mt-3" :items="workOrder.files" no-section-name />

        <p class="mt-3">Crew members present: 10</p>
        <p>Crew leader present: <span class="font-bold">Y</span></p>

        <div class="mt-3">
          <i class="fas fa-check fa-fw text-lg text-red" />
          <span class="ml-2 uppercase font-bold">{{ workOrder.status }}</span>
        </div>
      </div>
    </template>
  </list-view-cell>
</template>

<script>
import { ContextMenuItem } from "../../../../helper-classes/ContextMenuItem";
import ListViewCell from "../ListViewCell";
import BdgFilesList from "../../../files-list/BdgFilesList";
import WorkOrderForm from "../../../../views/contracts/forms/WorkOrderForm";

export default {
  name: "WorkOrderCell",
  components: { BdgFilesList, ListViewCell },
  props: {
    workOrder: Object
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: WorkOrderForm,
            createEditComponentData: this.workOrder,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: undefined,
            bodyComponentData: this.workOrder,
            isShown: true
          });
        })
      ]
    };
  }
};
</script>

<style scoped></style>
